import React from 'react';

import { string, shape, bool } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../../.internal/BaseComponent';
import ListItem from '../../.internal/list/list_item/ListItem';

import './DropdownItem.scss';

export default class DropdownItem extends BaseComponent {
  render() {
    const { children, onClick, style, id, className } = this.props;

    const classes = ['Dropdown-item', className];

    const classNames = ClassNames(classes);

    return (
      <ListItem onClick={onClick} className={classNames} style={style} id={id}>
        {children}
      </ListItem>
    );
  }
}

DropdownItem.propTypes = {
  active: bool,
  style: shape({}),
  id: string,
  className: string
};

DropdownItem.defaultProps = {
  active: false,
  style: {},
  id: undefined,
  className: undefined
};
